import { isAxiosError } from 'axios'

const collectMessages = (value: unknown): string[] => {
  if (typeof value === 'string') return [value]
  if (Array.isArray(value)) return value.flatMap(collectMessages)
  if (value && typeof value === 'object') {
    return Object.values(value).flatMap(collectMessages)
  }
  return []
}

export const getApiErrorMessage = (
  error: unknown,
  fallback = 'Une erreur est survenue lors de la sauvegarde.',
): string => {
  if (!isAxiosError(error)) return fallback
  return collectMessages(error.response?.data).join(' ') || fallback
}
